import React from 'react';

// A small info icon that reveals a concise explanation on hover/focus. Used in the
// dashboard chart-card headers so admins know what each graph is for. The text is
// always in the DOM (for screen readers via aria-label + role="tooltip") and is
// only visually revealed on hover/focus.
const InfoTooltip = ({ text }: { text: string }) => (
  <span className="group relative inline-flex shrink-0 align-middle">
    <button
      type="button"
      aria-label={text}
      className="material-icons leading-none text-gray-400 hover:text-gray-600 focus:outline-none cursor-help"
      style={{ fontSize: '16px' }}
    >
      info
    </button>
    <span
      role="tooltip"
      className="pointer-events-none absolute left-0 top-6 z-20 w-56 rounded-md bg-gray-800 px-3 py-2 text-xs font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
    >
      {text}
    </span>
  </span>
);

export default InfoTooltip;
